import React, { ChangeEvent, useMemo, useState ,useEffect, ReactNode} from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { toast, ToastContainer } from "react-toastify";
import "../admin.scss";
//import { fetchModelDetails } from "../../../api";
import { fetchModelDetails, tenantOnboarding,uploadLogo } from "../../../api";
import { BackendURL } from "../../../../env";

type ExpandedSection =
  | "company"
  | "admin"
  | "assignment"
  | "database"
  | "hosting"
  | false;

  type OnboardingForm = {
  organizationType: string;
  companyName: string;
  companyEmail: string;
  telephone: string;
  address: string;
  category: string;
  companyShortName: string;

  databaseHosting: string;
  subCategory: string;

  adminName: string;
  adminEmail: string;
  adminMobile: string;
  modelProvider: string;
  modelName: string;
  modelAccess: boolean;
  appName: string;
  appAccess: boolean;
  databaseName: string;
  databaseUrl: string;
  databaseUser: string;
  hostingType: string;
  webAppUrl: string;
  environment: string;
  hostingActive: boolean;
};

const initialForm: OnboardingForm = {
  organizationType: "",
  companyName: "",
  companyEmail: "",
  telephone: "",
  address: "",
category:"",
  databaseHosting: "",
  subCategory: "",
  companyShortName: "",

  adminName: "",
  adminEmail: "",
  adminMobile: "",
  modelProvider: "",
  modelName: "",
  modelAccess: true,
  appName: "",
  appAccess: true,
  databaseName: "",
  databaseUrl: "",
  databaseUser: "",
  hostingType: "",
  webAppUrl: "",
  environment: "",
  hostingActive: true,
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

type NativeFieldProps = {
  label: string;
  value: string;
  required?: boolean;
  type?: string;
  rows?: number;
  onChange: (value: string) => void;
};



const NativeField = ({
  label,
  value,
  required = false,
  type = "text",
  rows,
  onChange,
}: NativeFieldProps) => (
  <label className="company-form-field">
    <span>
      {label}
      {required && <em>*</em>}
    </span>
    {rows ? (
      <textarea
        rows={rows}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    ) : (
      <input
        type={type}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    )}
  </label>
);


//   label,
//   value,
//   required = false,
//   options,
//   onChange,
// }: NativeSelectProps) => (
//   <label className="company-form-field company-form-field-select">
//     <span>
//       {label}
//       {required && <em>*</em>}
//     </span>
//     <select value={value} onChange={(event) => onChange(event.target.value)}>
//       <option value="">Select {label}</option>
//       {options.map((option) => (
//         <option key={option} value={option}>
//           {option}
//         </option>
//       ))}
//     </select>
//   </label>
// );

const LipiLoader = () => (
  <div className="lipiLoaderWrapper">
    <div className="lipiLoaderIconWrapper">
      <span className="lipitext">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 58 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M55.0589 4.27963C54.4429 4.27963 53.9133 4.0797 53.4702 3.67984C53.0379 3.27997 52.8218 2.77204 52.8218 2.15603C52.8218 1.54002 53.0379 1.02668 53.4702 0.616008C53.9133 0.205336 54.4429 0 55.0589 0C55.6965 0 56.2368 0.205336 56.6799 0.616008C57.123 1.02668 57.3446 1.54002 57.3446 2.15603C57.3446 2.73961 57.123 3.24215 56.6799 3.66363C56.2368 4.0743 55.6965 4.27963 55.0589 4.27963ZM56.9231 22.4843C56.9231 23.5228 56.0812 24.3647 55.0426 24.3647C54.0041 24.3647 53.1622 23.5228 53.1622 22.4843V9.64539C53.1622 8.60684 54.0041 7.76494 55.0426 7.76494C56.0812 7.76494 56.9231 8.60684 56.9231 9.64538V22.4843Z"
          />
          <path
            d="M37.2763 21.3745C37.2683 21.3616 37.2541 21.3535 37.2389 21.3535C37.2148 21.3535 37.1952 21.3731 37.1952 21.3973V30.0221C37.1952 31.1145 36.3096 32 35.2173 32C34.1249 32 33.2393 31.1144 33.2393 30.0221V8.38873C33.2393 7.29634 34.1249 6.4108 35.2173 6.4108H35.6547C36.5055 6.4108 37.1952 7.1005 37.1952 7.95128V9.44848C37.1952 9.47239 37.2146 9.49177 37.2385 9.49177C37.2539 9.49177 37.2682 9.48341 37.276 9.47009C38.6284 7.1567 40.6021 6 43.1972 6C45.4138 6 47.1417 6.78165 48.3807 8.34496C49.6198 9.90827 50.2393 12.0079 50.2393 14.6438C50.2393 17.5651 49.5402 19.9043 48.142 21.6616C46.7438 23.4189 44.8341 24.2976 42.4128 24.2976C40.1928 24.2976 38.4806 23.3232 37.2763 21.3745Z"
            fill="#0D0D0D"
          />
          <path
            d="M25.9636 23.0058C25.9623 22.9454 25.9369 22.8879 25.8925 22.8452C25.8481 22.8025 25.7882 22.778 25.7254 22.7768L18.6226 22.7775L16.095 16.4468C15.987 16.0827 15.9708 15.699 16.0478 15.3277C16.1248 14.9563 16.2927 14.608 16.5376 14.3114L21.3062 8.54369C21.4474 8.37108 21.6283 8.2322 21.8346 8.13792C22.0409 8.04364 22.2671 7.99651 22.4956 8.0002C22.7074 7.99972 22.9047 8.03565 23.0888 8.10775C23.2729 8.17986 23.4401 8.28669 23.5805 8.42194C23.6215 8.46137 23.6601 8.50304 23.696 8.54675L28.4638 14.313C28.7101 14.6124 28.8782 14.9642 28.9541 15.3389C29.03 15.7136 29.0115 16.1003 28.9001 16.4667L27.8977 19.3235C27.8803 19.3742 27.8527 19.4211 27.8163 19.4615C27.78 19.5019 27.7357 19.535 27.6861 19.5588C27.6364 19.5827 27.5823 19.5969 27.5269 19.6006C27.4715 19.6043 27.4159 19.5974 27.3632 19.5803L25.727 21.9669C25.8688 21.9668 26.0092 21.9935 26.1402 22.0456C26.2712 22.0977 26.3903 22.1742 26.4905 22.2706C26.5908 22.367 26.6703 22.4814 26.7245 22.6074C26.7787 22.7333 26.8065 22.8683 26.8064 23.0046L26.8068 24.9599C26.8067 25.2352 26.6929 25.4992 26.4904 25.6939C26.2879 25.8885 26.0134 25.9979 25.727 25.998L16.8519 25.9999C16.796 26.0009 16.7405 25.9911 16.6885 25.9712C16.6366 25.9513 16.5893 25.9217 16.5494 25.884C16.5095 25.8464 16.4778 25.8015 16.4562 25.7519C16.4345 25.7023 16.4233 25.6491 16.4233 25.5954L25.7266 25.19C25.7579 25.1902 25.789 25.1844 25.818 25.1729C25.8469 25.1615 25.8733 25.1446 25.8954 25.1233C25.9176 25.102 25.9351 25.0767 25.947 25.0489C25.9589 25.021 25.965 24.9912 25.9648 24.961L25.9636 23.0058Z"
            fill="#DA2128"
            stroke="#DA2128"
            strokeWidth="0.9"
          />
          <circle cx="23.2471" cy="2.24705" r="2.24705" fill="#DA2128" />
          <path
            d="M14 25.2513C14 26.2171 13.2171 27 12.2513 27H2C0.895431 27 0 26.1046 0 25V2C0 0.895431 0.895431 0 2 0H2.19647C3.30104 0 4.19647 0.895431 4.19647 2V21.5026C4.19647 22.6071 5.0919 23.5026 6.19647 23.5026H12.2513C13.2171 23.5026 14 24.2855 14 25.2513Z"
            fill="#0D0D0D"
          />
        </svg>
      </span>
      <div className="lipiLoaderSpinner"></div>
    </div>
  </div>
);

const CompanyOnboarding: React.FC = () => {
  const [expanded, setExpanded] = useState<ExpandedSection>("company");
  const [form, setForm] = useState<OnboardingForm>(initialForm);
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoPreview, setLogoPreview] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState("");
const [mappingData, setMappingData] = useState<any[]>([]);
const [modelData, setModelData] = useState<any[]>([]);
const [logoUrl, setLogoUrl] = useState("");
  const [databaseform, setDatabaseForm] = useState({
  databaseHosting: "",
  subCategory: "",
});

const updateDatabaseField = (field:any, value:any) => {
  setDatabaseForm((prev) => ({
    ...prev,
    [field]: value,
  }));
};

const handleAddMapping = () => {
  if (!form.category) {
    toast.error("Please select Category");
    return;
  }

  if (!form.modelProvider) {
    toast.error("Please select Model Provider");
    return;
  }

  if (
    (form.category === "Model" && !form.modelName) ||
    (form.category === "App" && !form.appName)
  ) {
    toast.error(
      form.category === "Model"
        ? "Please select Model Name"
        : "Please select App Name"
    );
    return;
  }

  const selectedModel = modelData.find(
    (x) => String(x.ID) === String(form.modelName)
  );

  const selectedApp = modelData.find(
    (x) => String(x.ID) === String(form.appName)
  );

  const newItem = {
    category: form.category,
    provider: form.modelProvider,
    id: form.category === "Model" ? form.modelName : form.appName,
    name:
      form.category === "Model"
        ? selectedModel?.Display_Name
        : selectedApp?.Display_Name,
  };

  const exists = mappingData.some(
    (x) =>
      x.category === newItem.category &&
      x.provider === newItem.provider &&
      x.id === newItem.id
  );

  if (exists) {
    toast.error("Duplicate entry already exists");
    return;
  }

  setMappingData((prev) => [...prev, newItem]);

  updateField("category", "");
  updateField("modelProvider", "");
  updateField("modelName", "");
  updateField("appName", "");

  toast.success("Record added successfully");
};

// const handleAddMapping = () => {
//   const selectedModel = modelData.find(
//     (x) => String(x.ID) === String(form.modelName)
//   );

//   const selectedApp = modelData.find(
//     (x) => String(x.ID) === String(form.appName)
//   );

//   const newItem = {
//     category: form.category,
//     provider: form.modelProvider,
    
 
//     id:
//       form.category === "Model"
//         ? form.modelName
//         : form.appName,

   
//     name:
//       form.category === "Model"
//         ? selectedModel?.Display_Name
//         : selectedApp?.Display_Name,
//   };

//   const exists = mappingData.some(
//     (x) =>
//       x.category === newItem.category &&
//       x.provider === newItem.provider &&
//       x.id === newItem.id
//   );

//   if (exists) {
//     toast.error("Duplicate entry already exists");
//     return;
//   }

//   setMappingData((prev) => [...prev, newItem]);

//   updateField("modelProvider", "");
//   updateField("modelName", "");
//   updateField("appName", "");
// };

// const handleAddMapping = () => {
//   const newItem = {
//     category: form.category,
//     provider:form.modelProvider,
//     name:
//       form.category === "Model"
//         ? form.modelName
//         : form.appName,
//   };

//   const exists = mappingData.some(
//     (x) =>
//       x.category === newItem.category &&
//       x.provider === newItem.provider &&
//       x.name === newItem.name
//   );

//   if (exists) {
//     toast.error("Duplicate entry already exists");
//     return;
//   }

//   setMappingData((prev) => [...prev, newItem]);

//   updateField("modelProvider", "");
//   updateField("modelName", "");
//   updateField("appName", "");
// };


const handleDelete = (index: number) => {
  setMappingData((prev) =>
    prev.filter((_, i) => i !== index)
  );

  toast.success("Record removed successfully");
};

  const requiredFields = useMemo(
    () => [
      "organizationType",
      "companyName",
      "companyEmail",
      "telephone",
      "adminName",
      "adminEmail",
      "adminMobile",
      "modelProvider",
      "modelName",
      "appName",
      "databaseName",
      "databaseUrl",
      "hostingType",
      "webAppUrl",
    ],
    [],
  );


type NativeSelectProps = NativeFieldProps & {
  options?: string[];
  disabled?: boolean;
  children?: ReactNode;
};

const NativeSelect = ({
  label,
  value,
  required = false,
  options = [],
  disabled = false,
  children,
  onChange,
}: NativeSelectProps) => (
  <label className="company-form-field company-form-field-select">
    <span
      style={{
        color: disabled ? "#888" : "#000",
      }}
    >
      {label}
      {required && <em>*</em>}
    </span>

    <select
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
      style={{
        backgroundColor: disabled ? "#f1f1f1" : "#fff",
        color: disabled ? "#888" : "#000",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <option value="">Select {label}</option>

      {children
        ? children
        : options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
    </select>
  </label>
);

const getDisplayName = (id: string) => {
  return (
    modelData.find((x) => String(x.Model_id) === String(id))
      ?.Display_Name || id
  );
};

  const isSubmitDisabled = requiredFields.some(
    (field) => !String(form[field as keyof OnboardingForm]).trim(),
  );

  const updateField = (
    field: keyof OnboardingForm,
    value: string | boolean,
  ) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setStatus("");
  };

  const handleAccordionChange =
    (section: Exclude<ExpandedSection, false>) =>
    (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? section : false);
    };

 const handleLogoChange = async (
  event: ChangeEvent<HTMLInputElement>
) => {
  const file = event.target.files?.[0];

  if (!file) return;

  if (!file.type.startsWith("image/")) {
    toast.error("Please upload a valid logo image.");
    return;
  }

  try {
    setIsSubmitting(true);

    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));

    // Upload immediately
    const uploadedUrl = await uploadLogo(file);

    setLogoUrl(uploadedUrl.image_blob_url);

    console.log("Logo URL---------------------:", uploadedUrl);

    toast.success("Logo uploaded successfully");
  } catch (err) {
    toast.error("Logo upload failed");
  } finally {
    setIsSubmitting(false);
  }
};

  const handleRemoveLogo = () => {
    setLogoFile(null);
    setLogoPreview("");
  };

  const handleReset = () => {
    setForm(initialForm);
    handleRemoveLogo();
    setExpanded("company");
    setStatus("");
  };


//   const uploadLogoAndGetUrl = async (file: File) => {
//   const formData = new FormData();

//   formData.append("file", file);
//  // formData.append("Email", "shubham.raj@motherson.com");

//   const response = await fetch(`${BackendURL}/get_pdf_url`, {
//     method: "POST",
//     body: formData,
//   });

//   if (!response.ok) {
//     throw new Error("Failed to upload logo");
//   }

//   const result = await response.json();

//   return result.image_blob_url;
// };

const requiredFormFields = [
  form.organizationType,
  form.companyName,
  form.companyShortName,
  form.companyEmail,
  form.telephone,
  form.adminName,
  form.adminEmail,
  form.adminMobile,
  form.databaseHosting,
  form.subCategory,
  form.databaseUrl,
  form.databaseName,
  form.hostingType,
  form.webAppUrl,
];

const isFormValid =
  requiredFormFields.every(
    (field) => field && String(field).trim() !== ""
  ) &&
  mappingData.length > 0;


//   const uploadLogoAndGetUrl = async (file: File) => {
//   const formData = new FormData();
//   formData.append("file", file);

//   const response = await fetch(`${BackendURL}/get_pdf_url`, {
//     method: "POST",
//     body: formData,
//   });

//   if (!response.ok) {
//     throw new Error("Failed to upload logo");
//   }

//   const result = await response.json();

//   return result.image_blob_url;
// };




const handleSubmit = async () => {
  try {
    setIsSubmitting(true);
    const payload = {
      Company_Short_Name: form.companyShortName,
      Organization_Type: form.organizationType,
      Company_Name: form.companyName,
      Company_Email: form.companyEmail,
      Company_Telephone: form.telephone,
      Company_Address: form.address,
      Logo: logoUrl,
      Admin_Name: form.adminName,
      Admin_Email: form.adminEmail,
      Mobile_No: form.adminMobile,

      Model_Ids: mappingData.map((x) => x.id).join(","),

      Database_Hosting: form.databaseHosting,
      Database_Provider: form.subCategory,
      Database_URL: form.databaseUrl,
      Database_UserName: form.databaseName,
      Database_Password: form.databaseUser,

      Hosting_Type: form.hostingType,
      WebApp_URL: form.webAppUrl,
      Environment: form.environment,
    };

    console.log("Onboarding Payload:", payload);
    const result = await tenantOnboarding(payload);

    if (result?.success) {
      toast.success("Company onboarding submitted successfully.");

      handleReset();
    } else {
      toast.error(result.message || result.error || "Something went wrong");
    }

  } catch (err: any) {
    toast.error(err.message || "Request failed");
  } finally {
    setIsSubmitting(false);
  }
};


  // const handleSubmit = async () => {
  //   if (isSubmitDisabled) {
  //     toast.error("Please fill all required company onboarding fields.");
  //     return;
  //   }

  //   try {
  //     setIsSubmitting(true);
  //     setStatus("");

  //     const payload = {
  //       ...form,
  //       logoFileName: logoFile?.name || "",
  //       requestedBy: localStorage.getItem("Email") || "",
  //       tenantId: localStorage.getItem("TenantId") || "1",
  //     };

  //     const response = await fetch("/company_onboarding", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       throw new Error("Company onboarding endpoint is not available.");
  //     }

  //     toast.success("Company onboarding submitted successfully.");
  //     setStatus("Company onboarding submitted successfully.");
  //     handleReset();
  //   } catch (error: any) {
  //     const message =
  //       error?.message || "Unable to submit company onboarding details.";
  //     toast.error(message);
  //     setStatus(message);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };


  useEffect(() => {
  loadModelDetails();
}, []);

const loadModelDetails = async () => {
  try {
    const data = await fetchModelDetails();
    setModelData(data);
  } catch (error) {
    console.error("Error loading model details", error);
    toast.error("Failed to load model details");
  }
};

const providerOptions = [
  ...new Set(
    modelData
      .filter((x) => x.Category === "Model")
      .map((x) => x.Provider_Name)
  ),
];


  return (
    <div className="company-onboarding-page">
      <div className="admin-card company-onboarding-card">
        <div className="admin-card-body">
          <Typography className="company-onboarding-subtitle">
            Add organization details, admin user, model/app access, database,
            and hosting information for a new company.
          </Typography>

          <Accordion
            expanded={expanded === "company"}
            onChange={handleAccordionChange("company")}
            className="company-onboarding-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="modelMgmt-titleWrapper"
            >
              <Typography variant="h4">Company Info</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <div className="company-logo-upload">
                    <Button
                      component="label"
                      variant="contained"
                      className="company-logo-button"
                      startIcon={<CloudUploadIcon />}
                    >
                      Upload Logo
                      <VisuallyHiddenInput
                        type="file"
                        accept="image/*"
                        onChange={handleLogoChange}
                      />
                    </Button>
                    <div className="company-logo-preview">
                      {logoPreview ? (
                        <>
                          <img src={logoPreview} alt="Company logo preview" />
                          <button
                            type="button"
                            onClick={handleRemoveLogo}
                            aria-label="Remove company logo"
                          >
                            <DeleteIcon />
                          </button>
                        </>
                      ) : (
                        <span>Logo</span>
                      )}
                    </div>
                    {logoFile && <strong>{logoFile.name}</strong>}
                  </div>
                </Grid>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <NativeSelect
                        label="Organization Type"
                        required
                        value={form.organizationType}
                        options={["Motherson", "External", "Partner"]}
                        onChange={(value) => updateField("organizationType", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <NativeField
                        label="Company Name"
                        required
                        value={form.companyName}
                        onChange={(value) => updateField("companyName", value)}
                      />
                    </Grid>
                      <Grid item xs={12} md={6}>
                      <NativeField
                        label="Company Short Name"
                        required
                        value={form.companyShortName}
                        onChange={(value) => updateField("companyShortName", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <NativeField
                        label="Company Email"
                        required
                        type="email"
                        value={form.companyEmail}
                        onChange={(value) => updateField("companyEmail", value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {/* <NativeField
                        label="Telephone"
                        required
                    
                        value={form.telephone}
                        onChange={(value) => updateField("telephone", value)}
                      /> */}

                        <NativeField
                          label="Telephone"
                          required
                          type="tel"
                          value={form.telephone}
                          onChange={(value) =>
                            updateField(
                              "telephone",
                              value.replace(/\D/g, "").slice(0, 10)
                            )
                          }
                        />
                    </Grid>
                      <Grid item xs={12} md={6}>
                    {/* <Grid item xs={12}> */}
                      <NativeField
                        label="Address"
                       // rows={3}
                        value={form.address}
                        onChange={(value) => updateField("address", value)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === "admin"}
            onChange={handleAccordionChange("admin")}
            className="company-onboarding-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="modelMgmt-titleWrapper"
            >
              <Typography variant="h4">Admin Information</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <NativeField
                    label="Name"
                    required
                    value={form.adminName}
                    onChange={(value) => updateField("adminName", value)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <NativeField
                    label="Email"
                    required
                    type="email"
                    value={form.adminEmail}
                    onChange={(value) => updateField("adminEmail", value)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <NativeField
                    label="Mobile"
                    required
                    value={form.adminMobile}
                    onChange={(value) => updateField("adminMobile", value)}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === "assignment"}
            onChange={handleAccordionChange("assignment")}
            className="company-onboarding-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="modelMgmt-titleWrapper"
            >
              <Typography variant="h4">Assign Model & App</Typography>
            </AccordionSummary>
            <AccordionDetails>

<Grid container spacing={2}>
  <Grid item xs={12} md={3}>
    <NativeSelect
      label="Category"
      required
      value={form.category}
      options={["Model", "App"]}
      onChange={(value) => {
        updateField("category", value);
        updateField("modelProvider", "");
        updateField("modelName", "");
        updateField("appName", "");
      }}
    />
  </Grid>

  <Grid item xs={12} md={3}>
    <NativeSelect
      label="Model Provider"
      required
      value={form.modelProvider}
      options={["OpenAI", "Azure", "Google", "Lipi"]}
      onChange={(value) => updateField("modelProvider", value)}
    />
  </Grid>

  <Grid item xs={12} md={3}>

    {/* <NativeSelect
  label="Model Name"
  value={form.modelName}
  options={modelOptions}
  onChange={(value) => updateField("modelName", value)}
  disabled={form.category !== "Model"}
/> */}

<NativeSelect
  label="Model Name"
  required
  value={form.modelName}
  onChange={(value) => updateField("modelName", value)}
  disabled={form.category !== "Model"}
>
  {modelData
    .filter((x) => x.Category === "Model")
    .map((item) => (
      <option
        key={item.ID}
        value={item.ID}
      >
        {item.Display_Name}
      </option>
    ))}
</NativeSelect>
  </Grid>

  <Grid item xs={12} md={3}>
    <NativeSelect
  label="App Name"
  required
  value={form.appName}
  onChange={(value) => updateField("appName", value)}
  disabled={form.category !== "App"}
>
  {modelData
    .filter((x) => x.Category === "App")
    .map((item) => (
      <option
        key={item.ID}
        value={item.ID}
      >
        {item.Display_Name}
      </option>
    ))}
</NativeSelect>
  </Grid>
</Grid>

 <Grid item xs={12} md={8}>
<Grid item xs={12}>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      marginTop: "16px",
    }}
  >
    <Button
      variant="contained"
         className="save-btn-usermgmt"
      onClick={handleAddMapping}
      sx={{
        minWidth: 140,
      }}
    >
      Add
    </Button>
  </div>
</Grid>
{mappingData.length > 0 && (
  <Grid item xs={12}>
    <div
      style={{
        marginTop: "20px",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ background: "#f5f5f5" }}>
            <th style={{ padding: "12px" }}>Category</th>
            <th style={{ padding: "12px" }}>Provider</th>
            <th style={{ padding: "12px" }}>Name</th>
            <th style={{ padding: "12px" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {mappingData.map((item, index) => (
            <tr
              key={index}
              style={{
                borderTop: "1px solid #e0e0e0",
              }}
            >
              <td style={{ padding: "12px" }}>
                {item.category}
              </td>

              <td style={{ padding: "12px" }}>
                {item.provider || "-"}
              </td>

              <td style={{ padding: "12px" }}>
                {item.name}
              </td>

              <td style={{ padding: "12px" }}>
                <Button
                  color="error"
                  size="small"
                  onClick={() => handleDelete(index)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Grid>
)}
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === "database"}
            onChange={handleAccordionChange("database")}
            className="company-onboarding-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="modelMgmt-titleWrapper"
            >
              <Typography variant="h4">Configure Database </Typography>
            </AccordionSummary>
            <AccordionDetails>

 
  <Grid container spacing={2}>
  
<Grid item xs={12} md={4}>
  <NativeSelect
    label="Database Hosting"
    required
    value={form.databaseHosting}
    options={["Cloud", "On-Premise"]}
    onChange={(value) => {
      updateField("databaseHosting", value);
      updateField("subCategory", "");
    }}
  />
</Grid>


  <Grid item xs={12} md={4}>
  <NativeSelect
  label="Database Provider"
  required
  value={form.subCategory}
  options={
    form.databaseHosting === "Cloud"
      ? ["AWS", "Amazon RDS", "Google Cloud", "Azure"]
      : form.databaseHosting === "On-Premise"
      ? ["SQL Server", "Oracle", "PostgreSQL"]
      : []
  }
  onChange={(value) => updateField("subCategory", value)}
/>
  </Grid>
    <Grid item xs={12} md={4}>
                  <NativeField
                    label="Database URL"
                    required
                    value={form.databaseUrl}
                    onChange={(value) => updateField("databaseUrl", value)}
                  />
                </Grid>
</Grid>


   <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <NativeField
                    label="Database Username"
                    required
                    value={form.databaseName}
                    onChange={(value) => updateField("databaseName", value)}
                  />
                </Grid>


                <Grid item xs={12} md={4}>
                  <NativeField
                    label="Database Password"
                    value={form.databaseUser}
                    onChange={(value) => updateField("databaseUser", value)}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === "hosting"}
            onChange={handleAccordionChange("hosting")}
            className="company-onboarding-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="modelMgmt-titleWrapper"
            >
            <Typography variant="h4"> Configure Hosting </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <NativeSelect
                    label="Hosting Type"
                    required
                    value={form.hostingType}
                    options={["Web App", "API", "On Premise", "Cloud"]}
                    onChange={(value) => updateField("hostingType", value)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <NativeField
                    label="Web App URL"
                    required
                    value={form.webAppUrl}
                    onChange={(value) => updateField("webAppUrl", value)}
                  />
                </Grid>
                
                <Grid item xs={12} md={2}>
                  <NativeSelect
                    label="Environment"
                    value={form.environment}
                    options={["Dev", "UAT", "Prod"]}
                    onChange={(value) => updateField("environment", value)}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  {/* <FormControlLabel
                    className="company-onboarding-checkbox"
                    control={
                      <Checkbox
                        checked={form.hostingActive}
                        onChange={(event) =>
                          updateField("hostingActive", event.target.checked)
                        }
                      />
                    }
                    label="Active"
                  /> */}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>


          {status && (
            <Alert severity="info" className="company-onboarding-alert">
              {status}
            </Alert>
          )}

          <div className="company-onboarding-actions">
            <Button
              variant="outlined"
              className="close-btn-usermgmt"
              onClick={handleReset}
              disabled={isSubmitting}
            >
              Reset
            </Button>
   <Button
  variant="contained"
  className="save-btn-usermgmt"
  onClick={handleSubmit}
  disabled={!isFormValid || isSubmitting}
>
  Submit
</Button>
          </div>
        </div>

        {isSubmitting && <LipiLoader />}
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default CompanyOnboarding;



